import React from "react";
import styles from "./PrimaryNav.module.css";
import { useNavigate } from 'react-router-dom';

const PrimaryNav = () => {
  const navigate = useNavigate(); // Hook to navigate programmatically

  const handleNavigateHome = () => {
    navigate('/'); // Navigate to the home page
  }
  const handleButtonClick = () => {
    navigate('../createaccount'); // Navigate to the home page
  };

  return (
    <div className={styles.primarynav}>
      <section className={styles.primarynav1}>
        <div className={styles.members}>Members</div>
        <div className={styles.rules}>Rules</div>
        <div className={styles.polls}>Polls</div>
        <img
          className={styles.icon}
          loading="lazy"
          alt=""
          src="/2813821-1@2x.png"
          onClick={handleNavigateHome}
        />
      </section>
      
      <div className={styles.rightNav}>
        <div className={styles.login} onClick={handleButtonClick}>Login</div>
        <div className={styles.createAccount} onClick={handleButtonClick}>
          Create Account
        </div>
      </div>

      <div className={styles.fantasyHq} onClick={handleNavigateHome}>Fantasy LC</div>
    </div>
  );
};

export default PrimaryNav;
